var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrowave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    x: -50,
    y: -55,
    display: "none",
    fill: "#6DCFF6",
    width: 544,
    height: 455
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "microwave"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.7,9H8.3C3.9,9,0,12.9,0,17.2v29.6C0,51.1,3.9,55,8.3,55h47.5c4.3,0,8.3-3.9,8.3-8.2V17.2C64,12.9,60.1,9,55.7,9z  M62,46.8c0,3.2-3,6.2-6.3,6.2H8.3C5,53,2,50,2,46.8V17.2C2,14,5,11,8.3,11h47.5c3.2,0,6.3,3,6.3,6.2V46.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,16H14c-3.7,0-7,3.1-7,6.5v19.1C7,45,10.3,48,14,48h26h0c3.4,0,7-2,7-5.5v-20C47,19.1,43.7,16,40,16z M45,42.5 c0,2.3-2.6,3.5-5,3.5H14c-2.6,0-5-2.2-5-4.5V22.5c0-2.3,2.4-4.5,5-4.5h26c2.6,0,5,2.2,5,4.5V42.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,28.9c0-3.1,2.2-3.9,2.3-4c0.5-0.2,0.8-0.7,0.6-1.3c-0.2-0.5-0.7-0.8-1.3-0.6c-0.2,0.1-3.7,1.3-3.7,5.9 c0,1.4,0.9,2.7,1.8,3.8c0.6,0.8,1.2,1.7,1.2,2.3c0,1.3-0.9,2.7-2.6,4.1c-0.4,0.4-0.5,1-0.1,1.4c0.2,0.2,0.5,0.4,0.8,0.4 c0.2,0,0.4-0.1,0.6-0.2c2.3-1.9,3.4-3.7,3.4-5.7c0-1.3-0.8-2.4-1.6-3.5C31.7,30.7,31,29.7,31,28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,28.9c0-3.1,2.2-3.9,2.3-4c0.5-0.2,0.8-0.7,0.6-1.3c-0.2-0.5-0.7-0.8-1.3-0.6c-0.2,0.1-3.7,1.3-3.7,5.9 c0,1.4,0.9,2.7,1.8,3.8c0.6,0.8,1.2,1.7,1.2,2.3c0,1.3-0.9,2.7-2.6,4.1c-0.4,0.4-0.5,1-0.1,1.4c0.2,0.2,0.5,0.4,0.8,0.4 c0.2,0,0.4-0.1,0.6-0.2c2.3-1.9,3.4-3.7,3.4-5.7c0-1.3-0.8-2.4-1.6-3.5C22.7,30.7,22,29.7,22,28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,39c-2.2,0-4,1.8-4,4c0,2.2,1.8,4,4,4s4-1.8,4-4C58,40.8,56.2,39,54,39z M54,45c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2 S55.1,45,54,45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,28c-2.2,0-4,1.8-4,4c0,2.2,1.8,4,4,4s4-1.8,4-4C58,29.8,56.2,28,54,28z M54,34c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2 s2,0.9,2,2C56,33.1,55.1,34,54,34z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,17c-2.2,0-4,1.8-4,4c0,2.2,1.8,4,4,4s4-1.8,4-4C58,18.8,56.2,17,54,17z M54,23c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2 s2,0.9,2,2C56,22.1,55.1,23,54,23z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrowave);
export default __webpack_public_path__ + "static/media/microwave.1abf5033c95ee64df37fd36ed8fa41cc.svg";
export { ForwardRef as ReactComponent };